module.exports = __webpack_public_path__ + "static/media/synth_06.d387c73c.mp3";